import language from "../Images/icon/language.svg";
import arrow_back from "../Images/icon/arrow_back.svg";
import Isolation_Mode from "../Images/icon/Isolation_Mode.svg";
import search from "../Images/icon/search.svg";
import dot from "../Images/icon/dot.svg";
import fine_search from "../Images/icon/fine_search.svg";
import cancel_error from "../Images/icon/cancel-error.svg";
import iconUser from "../Images/icon/icon-user.svg";
import event from "../Images/icon/event.svg";
import excel from "../Images/icon/excel.svg";
import check_circle from "../Images/icon/check_circle.svg";
import plus_circle from "../Images/icon/plus-circle.svg";
import chart_bar from "../Images/icon/chart-bar.svg";
import factoryOutline from "../Images/icon/FactoryOutline.svg";
import fileScrollOutline from "../Images/icon/FileScrollOutline.svg";
import grainOutline from "../Images/icon/GrainOutline.svg";
import saveOutline from "../Images/icon/SaveOutline.svg";
import truckOutline from "../Images/icon/TruckOutline.svg";
import userGuardianOutline from "../Images/icon/UserGuardianOutline.svg";
import warehouseAOutline from "../Images/icon/WarehouseAOutline.svg";
import add from "../Images/icon/Add.svg";
import arrow_right from "../Images/icon/ArrowRight.svg";
import edit from "../Images/icon/Edit.svg";
import checkSmallOutline from "../Images/icon/CheckSmallOutline.svg";
import warning from "../Images/icon/warning.svg";
import truckCheck from "../Images/icon/truck_check.svg";
import searchPackage from "../Images/icon/searchPackage.svg";
import deleted from "../Images/icon/delete.svg";
import editOutline from "../Images/icon/edit-outline.svg";

import { InterfaceString } from "@interface/ICommon";

export const icons: InterfaceString = {
  language,
  arrow_back,
  arrow_right,
  search,
  dot,
  chart_bar,
  fine_search,
  Isolation_Mode,
  cancel_error,
  iconUser,
  event,
  excel,
  check_circle,
  plus_circle,
  factoryOutline,
  fileScrollOutline,
  grainOutline,
  saveOutline,
  truckOutline,
  userGuardianOutline,
  warehouseAOutline,
  add,
  edit,
  checkSmallOutline,
  warning,
  truckCheck,
  searchPackage,
  deleted,
  editOutline
};
